import { IStore } from '@store/index';
import { GetterTree } from 'vuex';
import { FaresState } from "./index";
import Fare from "./interfaces/fare";

export default {
    getSelectedFare: function (state, _, rootState): Fare|null {
        return state.availableFares.filter((fare) => fare.fare == rootState.checkout.fare)[0] ?? null;
    },
    funnelFares: (state: FaresState): Fare[] => {
        // create deep copy of availableFares to maintain the integrity of the state when modifying fares.
        const fares = JSON.parse(JSON.stringify(state.availableFares));

        fares.forEach((fare: Fare ) => {
            delete fare.fareUSPs;
            delete fare.fareDescription;
        });

        return fares;
    }
} as GetterTree<FaresState, IStore>
